/**
 * Ortam, adresteki alan adından (D-056 kuralı, Kabuk.tsx'teki etiketle aynı): "test." ile başlayan test sitesi,
 * localhost bu bilgisayar, ötekiler canlı. Yalnız test ve yerelde açılan deneme sayfaları bunu kullanır.
 */
export type Ortam = "test" | "yerel" | "canli";

export const ortamBul = (alanAdi: string): Ortam =>
  alanAdi.startsWith("test.") ? "test" : ["localhost", "127.0.0.1", "[::1]"].includes(alanAdi) ? "yerel" : "canli";

export const denemeAcik = () => typeof window !== "undefined" && ortamBul(window.location.hostname) !== "canli";
